export default __webpack_public_path__ + "static/media/photo--sm--gwen.6dbd6e03.jpg";